export const baseAPIUrl = process.env.REACT_APP_API_URL;
export const fallbackImage = 'https://peaklist-media-bucket.s3.amazonaws.com/pl-default-image.jpg';
export const demoAutoPopulate = 'https://peaklist-media-bucket.s3.amazonaws.com/demo-auto-populate.jpg';